import { Box } from '@pets-ui/Box/Box'
import { Chip } from '@pets-ui/Chip/Chip'
import { HStack } from '@pets-ui/HStack/HStack'
import { Radio } from '@pets-ui/Radio/Radio'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { type ComponentPropsWithoutRef, type ReactNode } from 'react'
import { ButlerItemImage } from '../ButlerListItem/ButlerItemImage'

const styles = stylex.create({
  root: {
    padding: 12,
    borderColor: {
      'default': colors.grey400,
      ':hover': colors.grey600,
    },
    borderRadius: 4,
    borderStyle: 'solid',
    borderWidth: 1,
    gap: 2,
    transition: 'border-color 0.2s',
    boxSizing: 'border-box',
    cursor: 'pointer',
    position: 'relative',
    width: '100%',
  },
  selected: {
    borderColor: colors.grey600,
    backgroundColor: colors.grey50,
  },
  chip: {
    borderRadius: 4,
    paddingInline: 4,
    backgroundColor: colors.violet100,
    color: colors.violet600,
    position: 'absolute',
    left: '-8px',
    top: '-8px',
  },
})

export interface CartSearchListItemProps extends Omit<ComponentPropsWithoutRef<'div'>, 'title'> {
  recommendedIndex?: number
  title?: ReactNode
  subTitle?: ReactNode
  productImgSrc?: string
  selected?: boolean
}

export const ButlerRecommendedListItem = (props: CartSearchListItemProps) => {
  const { title, subTitle, selected, recommendedIndex, productImgSrc, ...rest } = props
  return (
    <>
      <div
        {...stylex.props(
          styles.root,
          selected && styles.selected,
        )}
        {...rest}
      >
        {recommendedIndex && <Chip size="xSmall" rootStyle={styles.chip}>{`Top${recommendedIndex}`}</Chip>}
        <HStack gap={3} alignItems="center" position="relative" flexWrap="nowrap" overflow="hidden">
          {recommendedIndex && (
            <>
              <Radio color="blue" checked={selected} />
              <Box flexShrink={0}>
                <ButlerItemImage
                  productImgSrc={productImgSrc}
                  productTitle={title}
                  productImgWidth={48}
                />
              </Box>
            </>
          )}
          <VStack overflow="hidden" flex={1}>
            <Text ellipsis>{title}</Text>
            <Text variant="caption" color={colors.grey600} ellipsis>{subTitle}</Text>
          </VStack>
        </HStack>
      </div>
    </>
  )
}
